export default __webpack_public_path__ + "cc8a281d910fbb646210ae271f335313.png";